import * as React from 'react';

import { Clickable } from '../Clickable/Clickable';
import { Divider } from '../Divider/Divider';
import { routes } from '../../config/routes';
import { AuthorCard } from '../AuthorCard/AuthorCard';

import { ReactComponent as QuoteMark } from '../Quote/assets/quote-mark.svg';
import { ReactComponent as QuoteMarkMobile } from '../Quote/assets/quote-mark-mobile.svg';

import * as cs from './QuoteCard.module.css';

import type { IGatsbyImageData } from 'gatsby-plugin-image';

interface Props {
  title: string;
  name: string;
  about?: string;
  text: string;
  slug: string;
  logo: {
    publicURL: string;
  };
  trackEvent?: string;
  avatar?: IGatsbyImageData;
}

export const QuoteCard = ({
  name,
  about,
  text,
  title,
  slug,
  logo,
  avatar,
  trackEvent,
}: Props) => {
  const url = routes.client(slug);
  return (
    <>
      <article className={cs.root}>
        <Clickable
          className={cs.link}
          to={url}
          trackEvent={trackEvent}
          trackLabel={trackEvent ? url : undefined}
        >
          <div className={cs.wrapper}>
            <QuoteMarkMobile className={cs.quoteMarkMobile} aria-hidden />

            <div className={cs.textWrapper}>
              <QuoteMark className={cs.quoteMark} aria-hidden />

              <blockquote className={cs.text}>{text}</blockquote>

              <Divider isDecorative className={cs.hr} />

              <div className={cs.author}>
                <div>
                  <AuthorCard
                    largeAbout
                    name={name}
                    about={about}
                    avatar={avatar}
                  />
                </div>

                <div className={cs.logoWrapper}>
                  <img
                    className={cs.logo}
                    src={logo && logo.publicURL}
                    alt={`${title} Logo`}
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </Clickable>
      </article>
    </>
  );
};
